import React from "react";
import { Player } from "video-react";

const VideoModal = ({ data }) => {
  const player =
    data.video_type === "video_file" ? (
      <Player
        autoPlay={true}
        playsInline
        src={data.link}
      />
    ) : (
      <div
        className="video-responsive"
        style={{ height: "50vh", width: "100%" }}
      >
        <iframe
          title={data.link}
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${data.link}?autoplay=1&mute=1`}
        />
      </div>
    );

  return <>{player}</>;
};

export default VideoModal;
